// ----------------------------------------------------------------------------
// Открывает окошко авторизации через соцсети
// ----------------------------------------------------------------------------


const OpenAuth = (o, w, h) => {
    const href = o.getAttribute('href');

    if (!href) return;

    const left = (window.screen.width - w) / 2;
    const top = (window.screen.height - h) / 2;
    const windowFeatures = `scrollbars=1,resizable=1,menubar=0,toolbar=0,status=0,left=${left},top=${top},width=${w},height=${h}`;

    const popupWindow = window.open(href, "oauth_popup" + Math.random(), windowFeatures);

    if (popupWindow) {
        popupWindow.focus();
    } else {
        console.warn('Всплывающее окно авторизации было заблокировано браузером.');
    }
}

export default OpenAuth;
